// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header[data-v-e51d4144]{color:#fff;height:100%}.transition-ease-out[data-v-e51d4144],header[data-v-e51d4144]{transition:.2s ease-out}.fade-enter-active[data-v-e51d4144],.fade-leave-active[data-v-e51d4144]{transition:opacity .5s ease,height .5s}.fade-enter-from[data-v-e51d4144],.fade-leave-to[data-v-e51d4144]{opacity:0;transition:opacity .5s ease}@media (max-width:640px){.position[data-v-e51d4144]{position:absolute}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
